export default "__VITE_ASSET__D9d5CO$F__"